import { createSlice } from '@reduxjs/toolkit';

import {
  ProgrammeState,
  SetParentProgrammePayload,
  SetProgrammePayload,
  SetProgrammeSummariesPayload,
  SetProgrammesPayload,
  SetSubProgrammePayload
} from './programme.types';

export const initialState: ProgrammeState = {
  programme: undefined,
  programmes: undefined,
  programmeSummaries: undefined,
  parentProgramme: undefined,
  subProgramme: undefined
};

const ProgrammeSlice = createSlice({
  name: 'programme',
  initialState,
  reducers: {
    setProgramme: (state, action: SetProgrammePayload) => {
      state.programme = action.payload;
    },
    setProgrammes: (state, action: SetProgrammesPayload) => {
      state.programmes = action.payload;
    },
    setProgrammeSummaries: (state, action: SetProgrammeSummariesPayload) => {
      state.programmeSummaries = action.payload;
    },
    setParentProgramme: (state, action: SetParentProgrammePayload) => {
      state.parentProgramme = action.payload;
    },
    setSubProgramme: (state, action: SetSubProgrammePayload) => {
      state.subProgramme = action.payload;
    }
  }
});

export const { setProgramme, setProgrammes, setProgrammeSummaries, setParentProgramme, setSubProgramme } =
  ProgrammeSlice.actions;

export default ProgrammeSlice.reducer;
